module.exports = __webpack_public_path__ + "img/noti4.e96f8ad4.jpeg";